export enum SessionPermission {
  CREATE_PROJECTS = "CREATE_PROJECTS",
  POWERBI_REPORT = "POWERBI_REPORT",
  VIEW_QUICKSCAN = "VIEW_QUICKSCAN",
  VIEW_QUICKSCANS = "VIEW_QUICKSCANS",
  VIEW_SUCCESS = "VIEW_SUCCESS",
}
